import React, { lazy } from 'react';

const CarvanaProtectionComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-ancillary-products" */ './carvana-protection')
);

export const CarvanaProtectionRoute = () => {
  return <CarvanaProtectionComponent />;
};
